import { useRef } from 'react';
import styled from '@emotion/styled';
import Slide from '@base/Transitions/Slide';
import { useToggleable as useDrawer } from '@stores/toggleables';
import { Z_INDEX, DRAWER_IDS } from '@constants/index';
import Dynamic from '@base/Dynamic/Dynamic';
import useClassVideoPlayer from './hooks/useClassVideoPlayer';
import useLimitingClass from './hooks/useLimitingClass';

const ClassLimitedConsumption = Dynamic(() =>
  import('./ClassLimitedConsumption')
);

const Wrapper = styled(Slide)`
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  z-index: ${Z_INDEX.PLAYER};
`;

const ClassVideoPlayer = ({ internalFrame = false }) => {
  const iframeRef = useRef(null);

  const { key, urlToLoad, currentClassData, clock, onBackCleanup } =
    useClassVideoPlayer({
      iframeRef,
      internalFrame
    });
  const { isOpen: isPlayerOpen } = useDrawer(DRAWER_IDS.COURSE_CLASS_PLAYER);

  const {
    timeConsumed,
    timeConsumedBeforePlaying,
    handleBackOnBlocker,
    handleTimeBlockerView,
    handleGetSubscription,
    handleGotIt,
    isBlockerOpen
  } = useLimitingClass(clock, currentClassData, onBackCleanup);

  if ((timeConsumed || timeConsumedBeforePlaying) && isBlockerOpen)
    return (
      <ClassLimitedConsumption
        fullScreen={!timeConsumedBeforePlaying}
        onBack={handleBackOnBlocker}
        onGotIt={handleGotIt}
        onMount={handleTimeBlockerView}
        onSubscribe={handleGetSubscription}
      />
    );

  let iFrameConfig = 'fullscreen; camera; microphone;';
  if (!internalFrame) iFrameConfig += 'autoplay;';

  return (
    <Wrapper active={isPlayerOpen} direction="up">
      <iframe
        id="nativeIframeOne"
        key={key}
        src={urlToLoad}
        ref={iframeRef}
        webkitallowfullscreen="true"
        allowFullScreen="allowfullscreen"
        width="100%"
        height="100%"
        allow={iFrameConfig}
        frameBorder="no"
        title="Class"
      />
    </Wrapper>
  );
};

export default ClassVideoPlayer;
